import { render, staticRenderFns } from "./ExpartiateDescriptionViewV2.vue?vue&type=template&id=8610d70e&scoped=true"
import script from "./ExpartiateDescriptionViewV2.vue?vue&type=script&lang=js"
export * from "./ExpartiateDescriptionViewV2.vue?vue&type=script&lang=js"
import style0 from "./ExpartiateDescriptionViewV2.vue?vue&type=style&index=0&id=8610d70e&prod&lang=scss"
import style1 from "./ExpartiateDescriptionViewV2.vue?vue&type=style&index=1&id=8610d70e&prod&scoped=true&lang=scss"
import style2 from "./ExpartiateDescriptionViewV2.vue?vue&type=style&index=2&id=8610d70e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8610d70e",
  null
  
)

export default component.exports